import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';
import { Card } from '@/components/Card';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

/**
 * Help Center
 *
 * BugHerd #152: /help was a bare "Help Center - Coming Soon" div with no heading, no page
 * purpose and no onward route, while being a persistent navigation item for requesters.
 *
 * The full Help Center is not built. Rather than leave a promoted dead end, this states
 * that plainly and routes to the paths that do work today. Self-service comes first here,
 * which is what someone opening a help centre is looking for; Contact Support leads with
 * raising a ticket instead.
 */
export function HelpCenter() {
  useDocumentTitle('Help Center | SupportDesk');

  return (
    <div className="p-6">
      <div className="max-w-2xl">
        <div className="flex flex-wrap items-center gap-3 mb-2">
          {/* Matches the navigation label exactly so the destination identifies itself
              consistently with the control that leads to it. */}
          <h1 className="text-3xl font-bold text-gray-900">Help Center</h1>
        </div>

        <p className="text-gray-600 mb-6">
          These options can help
          you find an answer or reach the support team.
        </p>

        <Card className="p-6">
          <div className="flex flex-col sm:flex-row gap-3">
            <Link to="/knowledge-base" className="sm:w-auto">
              <Button variant="primary" fullWidth>
                Browse the Knowledge Base
              </Button>
            </Link>
            <Link to="/tickets/new" className="sm:w-auto">
              <Button variant="outline" fullWidth>
                Create a Support Ticket
              </Button>
            </Link>
          </div>

          <p className="text-sm text-gray-500 mt-4">
            Already raised something?{' '}
            <Link to="/tickets" className="text-primary-600 hover:text-primary-700 underline">
              View your tickets
            </Link>
            .
          </p>
        </Card>
      </div>
    </div>
  );
}
